// Детальная информация о клановых заданиях (экран /task/:key).
// Ключи совпадают с ключами заданий на бэке (задаются через админку).
// Фото задания: положи файл в src/assets/tasks/ и укажи здесь, например
//   import logoStoryPhoto from "../assets/tasks/logo-story.jpg";
// и ниже: { ..., image: logoStoryPhoto }. Пока image не задан — градиент-плейсхолдер.
import logoStoryPhoto from "../assets/tasks/logo-story.jpeg";

export interface TaskInfo {
  key: string;
  emoji: string;
  titleKey: string;
  descKey: string;
  image?: string;
  placeholder: string;
}

export const TASKS: TaskInfo[] = [
  {
    key: "logo_story",
    emoji: "🤸",
    titleKey: "task.logo_story.title",
    descKey: "task.logo_story.desc",
    image: logoStoryPhoto,
    placeholder: "linear-gradient(150deg, #4A2FA8, #1E1533)",
  },
  {
    key: "group_plank",
    emoji: "🧘",
    titleKey: "task.group_plank.title",
    descKey: "task.group_plank.desc",
    placeholder: "linear-gradient(150deg, #1E5F4E, #10201C)",
  },
  {
    key: "redbull_activity",
    emoji: "⚡",
    titleKey: "task.redbull_activity.title",
    descKey: "task.redbull_activity.desc",
    placeholder: "linear-gradient(150deg, #8A4A1E, #251208)",
  },
];

export const taskInfo = (key: string): TaskInfo | undefined => TASKS.find((t) => t.key === key);
